function initCheckout(){

    (function ($) {

        function change_customer_type(customer_type) {

            if (customer_type == 'company') {
                $('.payment_method_cheque').slideDown();
                $('#billing_company_field').removeClass('hidden-field');
                $('#billing_company').val('');
                $('#billing_company_field').animate({opacity: 1}, 300);
            } else {
                $('.payment_method_cheque').slideUp();
                $('#payment_method_paypal').prop('checked', true);
                $('#billing_company_field').addClass('hidden-field');
                $('#billing_company_field').animate({opacity: 0}, 300, function(){
                    $('#billing_company').val('No company');
                    $('#billing_company').trigger('blur');
                });
            }

        }

        change_customer_type($('#billing_type').val());

        $(document.body).on('updated_checkout', function(){
            change_customer_type($('#billing_type').val());
        });

        $('#billing_type').on('change', function(){

            var customer_type = $(this).val();

            change_customer_type(customer_type);
        });

    })(jQuery);

}